import { GetCurrentUserWorkspaceMemberships } from 'iam/WorkspaceMembershipStore'
import { action, computed, observable, makeObservable } from 'mobx'
import orderBy from 'lodash/orderBy'
import { IWorkspaceSearcher } from 'components/WorkspaceSelectorViewHeading'

/**
 * View model for managing the OCR scope work workspace selector.
 */
export default class OCRScopeWorkWorkspaceSearchViewModel
  implements IWorkspaceSearcher
{
  /**
   * User is searching a workspace.
   */
  @observable
  editing = false

  @observable
  searchText = ''

  /**
   * Constructor
   */
  constructor(
    private getCurrentUserWorkspaceMemberships: GetCurrentUserWorkspaceMemberships,
  ) {
    makeObservable(this)
  }

  /**
   * Whether the current user have the permission
   * to view the Scope Work jobs on the workspaces he's member of.
   */
  @computed
  get workspacesWhereUserCanViewScopeWorkJobs() {
    return orderBy(
      this.getCurrentUserWorkspaceMemberships()
        .filter(({ member }) => {
          return member.hasPermission('ADMIN_SCOPE_WORK_VIEW')
        })
        .map((m) => m.workspace),
      (ws) => ws.name.toLowerCase(),
      'asc',
    )
  }

  /**
   * Filtered workspaces.
   */
  @computed
  get filteredWorkspaces() {
    const result = this.workspacesWhereUserCanViewScopeWorkJobs

    if (this.searchText) {
      const searchText = this.searchText.toLowerCase()

      return result.filter((ws) =>
        ws.name.toLocaleLowerCase().includes(searchText),
      )
    }
    return result
  }

  /**
   * Sets the search text.
   *
   * @param searchText
   */
  @action.bound
  setSearchText(searchText: string) {
    this.searchText = searchText
  }

  @action.bound
  startEditing() {
    this.editing = true
  }

  @action.bound
  stopEditing() {
    this.editing = false
  }

  /**
   * Called when the view model is not being actively used.
   */
  deactivate() {
    this.setSearchText('')
  }
}
